<div class="cc-recipients-dialog">
    <div class="title-header">
        <span class="flex-1">{{ 'organisation.communication.cc.title' | translate }}</span>
        <button class="icon-button icon-close" (click)="cancel()" type="button"></button>
    </div>

    <div class="cc-recipients-dialog__content">
        <div class="cc-recipients-dialog__subtitle">
            {{ 'organisation.communication.cc.subtitle.' + communicationType | translate }}
        </div>

        <form [formGroup]="ccRecipientsForm" (ngSubmit)="addRecipient()" class="cc-recipients-dialog__add-form">
            <sag-ui-input
                class="flex-1"
                formControlName="email"
                [placeholder]="'organisation.communication.cc.placeholder' | translate"
                type="email"
            />
            <sag-ui-button type="submit" [disabled]="ccRecipientsForm.invalid" icon="plus">
                {{ 'organisation.communication.cc.add' | translate }}
            </sag-ui-button>
        </form>

        @if (ccRecipients.length) {
            <div class="cc-recipients-dialog__list">
                @for (email of ccRecipients; track email) {
                    <div class="cc-recipients-dialog__item">
                        <span class="cc-recipients-dialog__email">{{ email }}</span>
                        <button
                            class="icon-button icon-delete"
                            type="button"
                            (click)="removeRecipient(email)"
                            [title]="'default.buttons.delete' | translate"
                        ></button>
                    </div>
                }
            </div>
        } @else {
            <div class="cc-recipients-dialog__empty">
                {{ 'organisation.communication.cc.empty' | translate }}
            </div>
        }
    </div>

    <div class="form-button-container">
        <sag-ui-button type="button" (click)="save()">
            {{ 'default.buttons.save' | translate }}
        </sag-ui-button>
    </div>
</div>
